import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramBar } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBar';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const RankingMinAprDiagram = () => (
  <Diagram viewBox="0 0 300 110">
    <DiagramText x={34} y={14} tone={TextTone.MUTED} small anchor="start" tId="COST_FOR_YOU" />
    <DiagramText x={170} y={14} tone={TextTone.MUTED} small anchor="start" tId="CUSTOMER_APR" />
    {[
      { label: 'A', cost: 50, apr: 40, pos: '1º', win: true, y: 28 },
      { label: 'B', cost: 50, apr: 80, pos: '2º', win: false, y: 54 },
      { label: 'C', cost: 120, apr: 25, pos: '3º', win: false, y: 80 },
    ].map(({ label, cost, apr, pos, win, y }) => (
      <g key={label}>
        <DiagramText x={10} y={y + 10} anchor="start">
          {label}
        </DiagramText>
        <DiagramBar x={34} y={y} width={cost} win={win} />
        <DiagramBar x={170} y={y} width={apr} win={win} />
        <DiagramText x={260} y={y + 11} anchor="start" bold tone={win ? TextTone.YES : TextTone.DEFAULT}>
          {pos}
        </DiagramText>
      </g>
    ))}
    <DiagramText x={150} y={107} tone={TextTone.MUTED} small tId="MIN_APR_HINT" />
  </Diagram>
);
